
// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('product.variants', {
        url: '/variants',
        views: {'productList@product': {
            templateUrl: 'main/product/variants/variants.tpl.html',
            controller: 'VariantsController as vm'
        }},
        resolve: {
            variants: variantsResolver
        }
    });
}

// @ngInject
function variantsResolver(VariantsApiService) {
    return VariantsApiService.getVariants();
}

// @ngInject
function VariantsController($rootScope, $state, $scope, variants, loadSpinnerService) {
    var vm = this;

    vm.currentUser = $rootScope.currentUser;

    vm.variants = variants;
    vm.selectedVariantId = 0;
    vm.searchTerm = "";
    vm.currentPage = 1;
    vm.itemsPerPage = null;

    activate();

    function activate() {
        $scope.$watch(function() { return $state.params.variantId; }, function(newValue, oldValue) {
            vm.selectedVariantId = parseInt($state.params.variantId, 10);
        });
    }



}

angular
    .module('product.variants', ['variants.variant'])
    .config(stateConfig)
    .controller('VariantsController', VariantsController);
